import { RootState } from "../types";

export function connectorCertificationListForProjectSetup(state: RootState, projectSetupId?: number) {
    return state.connectorCertifications.list?.filter?.projectSetupId === projectSetupId
        ? state.connectorCertifications.list
        : undefined;
}
